// this mixin is used in the editor app well

Pegasus.DisableFrameLinks = Ember.Mixin.create({
  frameSelector: Em.required(),
  followAnchor: function( anchor, href, skip ){
    var doVisit = false;

    if ( anchor && href ) {
      if ( skip( href ) ) {
        window.alert( Em.I18n.t( "g.cannot_visit" ) );
      } else {
        doVisit = window.confirm( Em.I18n.t( "g.confirm_visit" ).fmt( href ) );
      }
      if ( doVisit ) {
        window.open( href, '_blank' );
      }
    }
  },
  skipAnchors: function( href ){
    var skipTest = /\{[A-Z_]+\}|^#$/,
      doSkip = false;

    if ( skipTest.test( href ) ) {
      doSkip = true;
    }
    return doSkip;
  },
  fixAnchors: function(){
    var frame = $( this.get('frameSelector') ),
      followAnchor = this.followAnchor,
      skip = this.skipAnchors,
      ready = function(){
        $(this).contents().find('a').off( 'click' );
        $(this).contents().find('a').on( 'click', function(e){
          var anchor = $( e.target ).closest( 'a' ),
              href = anchor.attr('href');

          followAnchor( anchor, href, skip );
          return false;
        });
        $(this).contents().find('a').addClass('vr-phase-loaded');
        $(this).contents().find('#unsubscribe_open').attr('contenteditable', 'false');
        $(this).contents().find('#unsubscribe_join').attr('contenteditable', 'false');
        $(this).contents().find('#unsubscribe_close').attr('contenteditable', 'false');
      };

    ready.call(frame);
  }
});
